const DEALER_USER = 'dealer-user'
const USER_TXT = '/user'
const TRANSPORT_CONTRACTOR = 'transport-contractor'
const NATIONAL_GOVERNMENT = 'national-government'
const NATIONAL_GOVERNMENT_USER = 'national-government-user'
const CPCB_GOVERNMENT = 'cpcb-government'
const CPCB_GOVERNMENT_USER = 'cpcb-government-user'
const SPCB_GOVERNMENT = 'spcb-government'
const SPCB_GOVERNMENT_USER = 'spcb-government-user'
const DISTRICT_GOVERNMENT = 'district-government'
const DISTRICT_GOVERNMENT_USER = 'district-government-user'
const RECYCLER = 'recycler'
const CONSUMER = 'consumer'
const CUSTOMER_USER = 'consumer-user'
const DEALER = 'dealer'
const REFURBISHER = 'material-producer'
const REFURBISHER_USER = 'material-producer-user'
const DISPOSER = 'disposer'
const DISPOSER_USER = 'disposer-user'
const SUPPLIER = 'supplier'
const SUPPLIER_USER = 'supplier-user'
const PRODUCER = 'producer'
const PRODUCER_USER = 'producer-user'
const TRADER = 'trading-company'
const TRADER_USER = 'trading-company-user'
const ADMIN = 'admin'
const THIRD_PARTY_RECYCLER = '3rd-party-recycler'
const THIRD_PARTY_RECYCLER_USER = '3rd-party-recycler-user'
const SECOND_HAND_BUYER = 'second-hand-buyer'
const SECOND_HAND_BUYER_USER = 'second-hand-buyer-user'
const SUPER_USER = 'super-user'
const RECYCLING_TECHNICIAN = 'recycling-technician'
const ACCOUNTS = 'accounts'
const FINANCE = 'finance'
const COMPLIANCE = 'compliance'
const DATA_ENTRY = 'data-entry'
const COLLECTION_CENTER = 'collection-center'
const SCRAPPING_FACILITY_MANAGER = 'scrapping-facility-manager'
const CATEGORY_USER = 'category-user'
const SALES_USER = 'sales-user'
const OPERATIONS_USER = 'operations-user'
const SCRAPPING_FACILITY_ENTRY_USER = 'scrapping-facility-entry-user'
const LIVE_BOARD = '/live-board'
const PROCUREMENT = 'procurement'
const OPERATIONS = 'operations'
const SALES = 'sales'

const pathName = {
  ROOT: '/',
  HOME: '/home',
  USER: `${USER_TXT}/:userType`,
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/forgot-password?:uuid',
  DATA_VISUALIZATION: '/data-visualization',
  ADD_USER: `${USER_TXT}/:userType/add`,
  PROFILE: `/profile`,
  JOBS: '/jobs',
  INVENTORY: '/inventory',
  ADD_JOB: '/jobs/:jobType/add',
  EDIT_JOB: '/jobs/:jobType/edit/:jobId',
  DASHBOARD: '/dashboard',
  VEHICLE_DETAILS: `/vehicle-details/:id`,
  PUBLIC_VEHICLE_DETAILS: `/public/vehicle-details/:id`,
  PART_DETAILS: `/part-details/:partName/:id`,
  BUCKET_MANAGEMENT: `/bucket-management`,
  CATEGORY_MANAGEMENT: `/category-management`,
  DASHBOARD_COMPLIANCE: '/dashboard-compliance',
  DASHBOARD_STATS: '/dashboard-stats',
  DASHBOARD_INDIA: '/dashboard-india',
  REPORT: `/report`,
  PUBLIC_JOB_DETAILS: `/public/job-details/:jobType`,
  LIVE_BOARD_PATH: `${LIVE_BOARD}/:boardNumber`,
  SETTINGS: `/settings`,
  SEARCH_REACT_FLOW: '/search',
  BULK_UPLOAD: '/jobs/bulk-upload',
  TRACE_SAMPLE: '/trace-sample',
  TRACE_ACTUAL: '/trace-actual',
  PLASTIC_TRACE_SAMPLE: '/plastic-trace-sample',
  PLASTIC_TRACE_ACTUAL: '/plastic-trace-actual',
  TRACE_END_TO_END: '/trace-end-to-end',
  TRACE_END_TO_END2: '/trace-end-to-end-2',
  VEHICLE_SALES: '/vehicle-sales',
}
export default pathName

export {
  USER_TXT,
  DEALER,
  LIVE_BOARD,
  DEALER_USER,
  TRANSPORT_CONTRACTOR,
  NATIONAL_GOVERNMENT,
  NATIONAL_GOVERNMENT_USER,
  CPCB_GOVERNMENT,
  CPCB_GOVERNMENT_USER,
  SPCB_GOVERNMENT,
  SPCB_GOVERNMENT_USER,
  DISTRICT_GOVERNMENT,
  DISTRICT_GOVERNMENT_USER,
  RECYCLER,
  CONSUMER,
  CUSTOMER_USER,
  REFURBISHER,
  REFURBISHER_USER,
  DISPOSER,
  DISPOSER_USER,
  SUPPLIER,
  SUPPLIER_USER,
  PRODUCER,
  PRODUCER_USER,
  TRADER,
  TRADER_USER,
  ADMIN,
  THIRD_PARTY_RECYCLER,
  THIRD_PARTY_RECYCLER_USER,
  SECOND_HAND_BUYER,
  SECOND_HAND_BUYER_USER,
  SUPER_USER,
  RECYCLING_TECHNICIAN,
  ACCOUNTS,
  FINANCE,
  COMPLIANCE,
  DATA_ENTRY,
  COLLECTION_CENTER,
  SCRAPPING_FACILITY_MANAGER,
  CATEGORY_USER,
  SALES_USER,
  OPERATIONS_USER,
  SCRAPPING_FACILITY_ENTRY_USER,
  PROCUREMENT,
  OPERATIONS,
  SALES,
}
